import { useEffect } from 'react'

/**
 * Full-page redirect to a server-served Astro route.
 *
 * Used so in-app client-side navigation (e.g. a <Link to="/docs">) lands on the
 * canonical Astro page instead of a divergent React copy. In client-only dev
 * there is no Astro server to hand off to, so we skip the redirect to avoid an
 * infinite loop — run the Astro dev server, or a production build, to view the
 * target there.
 */
export default function AstroRedirect({ to }: { to: string }) {
  useEffect(() => {
    if (import.meta.env.DEV) return
    window.location.replace(to)
  }, [to])

  return null
}
